

<template>
    <div class="account-warpper">
        <div class="bg-white ">
            <div class="margin-bottom-sm flex align-center justify-between">
                <div class="flex align-center">
                    <!--                    <div class="flex align-center margin-right-sm">-->
                    <!--                        <span>姓名：</span>-->
                    <!--                        <el-input v-model="searchName" placeholder="请输入姓名" class="flex-sub"></el-input>-->
                    <!--                    </div>-->
                    <!--                    <div class="flex align-center margin-right-sm">-->
                    <!--                        <span>手机号：</span>-->
                    <!--                        <el-input v-model="searchPhone" placeholder="请输入手机号" class="flex-sub"></el-input>-->
                    <!--                    </div>-->
                    <!--                    <el-button type="primary" @click="hanldSearch">搜索</el-button>-->
                </div>
                <el-button type="primary" @click="nameDialog = true">新增病种</el-button>
            </div>
            <el-table
                :data="accountList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%"
            >
                <el-table-column width="70" type="index" align="center" label="序号">
                </el-table-column>
                <el-table-column label="病种名称" prop="name"></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="danger"
                                @click="editItem(scope.row)"
                            >编辑
                            </el-button>
                            <el-button
                                size="small"
                                type="danger"
                                @click="deleteItem(scope.row.id)"
                            >删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="accountList.length > 0"
                class="page-all"
                background
                @current-change="getAdminList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
        <nameDialog
            :setId="setId"
            :setItem="setItem"
            :nameDialog="nameDialog"
            @cancelDialog="cancelDialog"
        />


    </div>
</template>

<script>
import { setLock, setPass} from "@/api/login";
import nameDialog from "@/views/serve/dialog/nameDialog";
import {powerTypes} from "@/utils/utils";
import { delIllness, getIllnessList} from "@/api/service";

export default {
    name: "disease",
    data() {
        return {

            page: 1,
            limit: 10,
            total: 0,
            accountList: [],
            setId: 0,
            setItem: {},
            nameDialog: false,
            regionDialog: false,
            imgDialog: false
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "预警中心 / 病种管理", false);
        this.getAdminList()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        powerList() {
            if (this.user.power === 3) {
                return [this.powerArr[0], this.powerArr[1], this.powerArr[2]]
            } else if (this.user.power === 4) {
                return [this.powerArr[0], this.powerArr[2]]
            } else if (this.user.power === 5) {
                return [this.powerArr[0], this.powerArr[3], this.powerArr[4], this.powerArr[5], this.powerArr[6]]
            } else if (this.user.power === 6) {
                return [this.powerArr[0], this.powerArr[5], this.powerArr[6]]
            } else {
                return this.powerArr
            }
        }
    },
    components: {
        nameDialog,
    },
    methods: {
        //  区域分配
        regionItem(id, obj) {
            this.setId = id;
            this.setItem = obj;
            this.regionDialog = true;
        },
        //  删除账号
        deleteItem(id) {
            this.$confirm('您确定要删除该信息吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delIllness(id);
            if (this.accountList.length === 1 && this.page > 1) {
                this.page--;
            }
            this.getAdminList();
            this.$message.success(_state.info);
        },
        //  初始化密码
        initialItem(id) {
            this.$confirm('初始化密码后该账号密码为123456', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureInitial(id);
            });
        },
        async sureInitial(id) {
            let _state = await setPass(id);
            this.$message.success(_state.info);
        },
        //  账号停用/启用
        setLockItem(id, state) {
            this.$confirm(state ? '您确定要停用该账号吗？' : '您确定要启用该账号吗', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureSetLock(id, state);
            });
        },
        async sureSetLock(id, state) {
            let _state = await setLock(id, state);
            this.$message.success(_state.info);
            this.getAdminList();

        },
        //  编辑
        editItem(obj) {
            this.setItem = obj;
            this.setId = obj.id;
            this.nameDialog = true;
        },
        setImg(obj) {
            this.setItem = obj;
            this.setId = obj.id;
            this.imgDialog = true;
        },
        //  员工信息编辑后回调
        cancelDialog(val) {
            if (val) {
                this.setId = 0;
                this.setItem = {};
                this.nameDialog = false;
                this.regionDialog = false;
                this.imgDialog = false;
                this.getAdminList();
            } else {
                this.setId = 0;
                this.setItem = {};
                this.regionDialog = false;
                this.nameDialog = false;
                this.imgDialog = false;
            }
        },
        //  搜索
        hanldSearch() {
            this.page = 1
            this.getAdminList()
        },
        //  获取列表
        async getAdminList() {
            let _list = await getIllnessList( this.page, this.limit)
            this.accountList = _list.data
            this.total = _list.total_number
        }
    },
    filters: {
        power(val) {
            return powerTypes(val)
        }
    },
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
